var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedininline = function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.8 1H2.2A1.2 1.2 0 0 0 1 2.2v15.6A1.2 1.2 0 0 0 2.2 19h15.6a1.2 1.2 0 0 0 1.2-1.2V2.2A1.2 1.2 0 0 0 17.8 1M6.332 16.356H3.624V7.75h2.708zM4.978 6.57a1.575 1.575 0 1 1 .01-3.15 1.575 1.575 0 0 1-.01 3.15m11.395 9.787H13.72v-4.162c0-1.013 0-2.25-1.41-2.25s-1.58 1.069-1.58 2.193v4.276H8.08V7.75h2.482v1.181h.056a2.82 2.82 0 0 1 2.539-1.406c2.707 0 3.215 1.8 3.215 4.106z"
  })));
};
export default SvgLinkedininline;